const LOGO_DEV_TOKEN = 'pk_PEgyuq_qQF2f_w3W2DlxRg'

/**
 * Extracts the hostname from a URL string.
 * Prepends https:// if no protocol is present.
 */
export const getDomain = url => {
  try {
    return new URL(url.startsWith('http') ? url : `https://${url}`).hostname
  } catch {
    return null
  }
}

/**
 * Returns a logo.dev image URL for the given website, or null if no valid domain.
 * @param {string} website - A URL or domain string
 * @param {number} [size=128] - Desired image size in pixels
 */
export const getLogoUrl = (website, size = 128) => {
  const domain = website ? getDomain(website) : null
  return domain
    ? `https://img.logo.dev/${domain}?token=${LOGO_DEV_TOKEN}&size=${size}`
    : null
}
